import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../../assets/Images/loader.gif'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import micon from "../../../assets/Images/schedule.png"

const BusinessMraAllContactHotel = () => {
  const [contactDataAll, setContactDataAll] = useState([]);
  const [contactDataOpen, setContactDataOpen] = useState([]);
  const [contactDataClose, setContactDataClose] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputAll, setSearchInputAll] = useState('');
  const [searchInputOpen, setSearchInputOpen] = useState('');
  const [searchInputClose, setSearchInputClose] = useState('');
  const [searchFilterAll, setSearchFilterAll] = useState([]);
  const [searchFilterOpen, setSearchFilterOpen] = useState([]);
  const [searchFilterClose, setSearchFilterClose] = useState([]);
  const [flagAll, setFlagAll] = useState(false);
  const [flagOpen, setFlagOpen] = useState(false);
  const [flagClose, setFlagClose] = useState(false);

 

  useEffect(() => {
    const fetchData = async (status, dataFuction) => {
      try {
        setLoading(true);
        // const currentDate = new Date();
        // const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        // const toDate = formattedCurrentDate;
        // const fromDate = new Date(currentDate);
        // fromDate.setMonth(currentDate.getMonth() - 2);
        // const formattedFromDate = fromDate.toISOString().split('T')[0];
        const currentDate = new Date();

        // Format the date correctly in YYYY-MM-DD format in local time
        const toDate = currentDate.getFullYear() + '-' +
          String(currentDate.getMonth() + 1).padStart(2, '0') + '-' +
          String(currentDate.getDate()).padStart(2, '0');

        const fromDate = new Date(currentDate);
        fromDate.setMonth(currentDate.getMonth() - 1);
        const formattedFromDate = fromDate.getFullYear() + '-' +
          String(fromDate.getMonth() + 1).padStart(2, '0') + '-' +
          String(fromDate.getDate()).padStart(2, '0');

        // console.log("toDate:", toDate);
        // console.log("fromDate:", formattedFromDate);


        // console.log("toDate", toDate);


        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: 'getAllContact',
          Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
          businessSegment: 'Business',
          fromDate: formattedFromDate,
          password: sessionStorage.getItem('password'),
          searchBoxValue: '',
          status: status,
          toDate: toDate,
          // toDate: "2025-04-03",
          industrySegment: "BDRhotel",
          productSegment: "",
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          //console.log('API Response:', result);
          if (result && result.Response && result.Response.Status !== 'Failure' && result.Response.Data !== undefined) {
            //console.log('Actual Data:', result.Response.Data);
            dataFuction(result.Response.Data)
          } else {
            const errorMessage = result && result.Response && result.Response.Message;
            // toast.warning(`${errorMessage}`, {
            //   position: toast.POSITION.BOTTOM_CENTER,
            //   autoClose: 1500,
            // });
          }
        } else {
          // console.error('Error fetching data:', response.status);
          toast.warning(response.status, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });

        }
      } catch (error) {
        // console.error('Error fetching data:', error);
        toast.warning(error, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData('All', setContactDataAll);
    fetchData('Open', setContactDataOpen);
    fetchData('Close', setContactDataClose);
  }, []);



  const handleSearchAll = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getAllContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        businessSegment: "Business",
        fromDate: "",
        password: sessionStorage.getItem('password'),
        searchBoxValue: searchInputAll,
        status: "not equal closed",
        toDate: "",
        industrySegment: "BDRhotel",
        productSegment: "",
        userName: sessionStorage.getItem('userName'),
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilterAll(result.Response.Data);
        setFlagAll(true);
      } else {
        // console.error("Invalid response format:", result);
        const errorMessage = result && result.Response && result.Response.Message;
        toast.warning(`${errorMessage}`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      // // console.error("Error fetching data:", error);
      // toast.warning(error, {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });
    } finally {
      setLoading(false);
    }
  };

  const handleSearchOpen = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getAllContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        businessSegment: "Business",
        fromDate: "",
        password: sessionStorage.getItem('password'),
        searchBoxValue: searchInputOpen,
        status: "Open",
        toDate: "",
        industrySegment: "BDRhotel",
        productSegment: "",
        userName: sessionStorage.getItem('userName'),
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilterOpen(result.Response.Data);
        setFlagOpen(true);
      } else {
        // console.error("Error fetching data:", response.status);
        const errorMessage = result && result.Response && result.Response.Message;
        // toast.warning(`${errorMessage}`, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
      toast.warning(error, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearchClose = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getAllContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        businessSegment: "Business",
        fromDate: "",
        password: sessionStorage.getItem('password'),
        searchBoxValue: searchInputClose,
        status: "Close",
        toDate: "",
        industrySegment: "BDRhotel",
        productSegment: "",
        userName: sessionStorage.getItem('userName'),
      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
        setSearchFilterClose(result.Response.Data);
        setFlagClose(true);
      } else {
        // console.error("Error fetching data:", response.status);
        const errorMessage = result && result.Response && result.Response.Message;
        // toast.warning(`${errorMessage}`, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
      toast.warning(error, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleBellClick = (e, ContactId) => {
    e.stopPropagation(); // Prevents the card's onClick event
    // console.log("SM button clicked for Contact ID:", ContactId);
    // Add further logic here if needed.
    navigate(`/businessMraHotelMeetings?ContactId=${ContactId}`);

  };

  // const updateForm = (ContactId) => {
  //   // navigate("/contactsManagementForm")
  //   navigate(`/businessPgContactForm?ContactId=${ContactId}`);
  // }

  const updateForm = (ContactId) => {
   
    navigate(`/businessMraContactFormHotel?ContactId=${ContactId}`);
  }

  const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/businessMraCardList");
  };

  // const redirectContactsForm = () => {
  //   navigate("/businessPgContactForm");
  // };

  const redirectContactsForm = () => {
  
    navigate("/businessMraContactFormHotel")
  };
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span className="" style={{ cursor: "pointer" }} onClick={redirectDashboardPage}>
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Hotel Market Research
          </span>
        </div>
        {/* Navigation tabs: ALL , OPEN , CLOSED */}
        <div className=" container-fluid">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className="nav-link active" data-bs-toggle="tab" href="#all">All</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#open">Open</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#closed">Closed</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content tab-main-content">
        {/* ****************** ALL contact TAB ************* */}
        <div className="tab-pane fade show active" id="all">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputAll}
                  onChange={(e) => setSearchInputAll(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchAll}>Search</button>
            </div>
          </div>

          {/* ***********All content of ALL contacts TAB************ */}
          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagAll && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {contactDataAll.map((contact, index) => (
                    <div className="col" key={index} onClick={() => updateForm(contact.ContactId)}>
                      <div className="card mb-3">
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                            <p className="contact-card-title"> {contact.PGName} </p>
                            <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                            <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                            <p className="contact-card-text">Status : {contact.Status}</p>
                            <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                            <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, contact.ContactId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {contact.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: contact.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {contact.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          )}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagAll && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilterAll.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => updateForm(contact.ContactId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                            <p className="contact-card-title"> {contact.PGName} </p>
                            <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                            <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                            <p className="contact-card-text">Status : {contact.Status}</p>
                            <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                            <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, contact.ContactId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {contact.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: contact.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {contact.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}



        </div>

        {/* ****************** open contacts TAB ************* */}
        <div className="tab-pane fade show" id="open">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputOpen}
                  onChange={(e) => setSearchInputOpen(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchOpen}>Search</button>
            </div>
          </div>

          {/* ***********All content of open contacts TAB************ */}
          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagOpen && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {contactDataOpen.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => updateForm(contact.ContactId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                            <p className="contact-card-title"> {contact.PGName} </p>
                            <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                            <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                            <p className="contact-card-text">Status : {contact.Status}</p>
                            <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                            <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, contact.ContactId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {contact.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: contact.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {contact.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagOpen && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilterOpen.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => updateForm(contact.ContactId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                            <p className="contact-card-title"> {contact.PGName} </p>
                            <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                            <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                            <p className="contact-card-text">Status : {contact.Status}</p>
                            <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                            <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, contact.ContactId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {contact.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: contact.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {contact.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}
        </div>

        {/* ****************** closed contacts TAB ************* */}
        <div className="tab-pane fade show" id="closed">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputClose}
                  onChange={(e) => setSearchInputClose(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchClose}>Search</button>
            </div>
          </div>

          {/* ***********All content of closed contacts TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagClose && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {contactDataClose.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => updateForm(contact.ContactId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                            <p className="contact-card-title"> {contact.PGName} </p>
                            <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                            <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                            <p className="contact-card-text">Status : {contact.Status}</p>
                            <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                            <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, contact.ContactId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {contact.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: contact.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {contact.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagClose && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilterClose.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => updateForm(contact.ContactId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                            <p className="contact-card-title"> {contact.PGName} </p>
                            <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                            <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                            <p className="contact-card-text">Status : {contact.Status}</p>
                            <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                            <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0",
                              transform: "translateY(-50%)"
                            }}
                          >
                            {/* Icon wrapper with relative positioning so the badge can be placed on top of it */}
                            <div
                              onClick={(e) => handleBellClick(e, contact.ContactId)}
                              style={{ position: "relative", cursor: "pointer", width: "30px", height: "30px" }}
                            >
                              {/* The Icon */}
                              <img
                                src={micon}
                                alt="Schedule Icon"
                                style={{ width: "30px", height: "30px" }}
                              />

                              {/* Red badge (only shown if there's a MeetingCounter) */}
                              {contact.MeetingCounter > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-5px",
                                    backgroundColor: contact.MeetingStatus == "0" ? "red" : "green",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {contact.MeetingCounter}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

        </div>
      </div>

      {/* ***********************  Add Icon************************** */}
      <div className='position-fixed bottom-0 end-0 m-4' onClick={redirectContactsForm}>
        <span className='bg-dark  rounded-circle faPlus-icon'>
          <i className="fa-solid fa-plus fa-lg text-light m-1"></i>
        </span>
      </div>

    </>
  )
}

export default BusinessMraAllContactHotel;
